/* 
 *  Created by RRamireddygari 02/14/2018
 */
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { GridOptions } from "ag-grid/main";
import { AppUtil } from "~util/app.util";
import { CommonService } from "~util/common.service";
import { RepoFolder } from "~config/model/repofolder";
import { RepofolderService } from "~config/services/repofolder.service";
import { RepofolderDetailComponent } from "~config/repofolder-detail/repofolder-detail.component";
import { EditComponent } from "~config/edit/edit.component";

declare var $: any;

@Component({
    selector: 'folderdetailwidget-grid',
    templateUrl: './folderdetailwidget-grid.component.html'
})
export class FolderdetailwidgetGridComponent implements OnChanges {

    @Input() folderId;

    gridOptions: GridOptions;
    columnDefs: any[]
    rowData: any[];
    isDisabled: boolean = true;
    style: {};
    tempRowData: {};
    selectedRow: {};
    isSyncing: boolean = false;
    public allMyFolderplaceholder: RepoFolder = new RepoFolder(3, 'ALL MYFOLDERS');
    public allCompFolderplaceholder: RepoFolder = new RepoFolder(2, 'ALL COMPANY FOLDERS');
    public allFolderplaceholder: RepoFolder = new RepoFolder(1, 'ALL STANDARD FOLDERS');
    //public allStandDetailplaceholder: RepoFolder = new RepoFolder(4, 'ALL DETAIL FOLDERS');
    //public allCompDetailplaceholder: RepoFolder = new RepoFolder(5, 'ALL COMPANY DETAIL FOLDERS');
    //public allWidgetReportsPlaceholder: RepoFolder = new RepoFolder(6, 'ALL WIDGET REPORTS');

    constructor(private service: RepofolderService, private AppUtil: AppUtil, private ddComponent: RepofolderDetailComponent, private commonService: CommonService) {
        this.gridOptions = AppUtil.getGridOptions('Please select folder');
        this.columnDefs = this.getColumnDef();
        this.style = { width: '100%', height: '100%' };
    }

    /*
    * This method will be called when we change folder id from drop down
    */
    ngOnChanges(changes: SimpleChanges) {
        //Disable Export button
        this.isDisabled = true;
        this.selectedRow = null;

        if (changes.folderId.currentValue == -1) {
            this.rowData = [];
        }
        else {
            this.gridOptions.api.showLoadingOverlay();
            this.getRowData();
            this.gridOptions.api.refreshCells();
        }
    }

    onGridReady(params) {
        // params.api.sizeColumnsToFit();
    }

    onSelectionChanged() {
        this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
    }

    getRowData() {
        this.service.getReportsInTheFolder(this.folderId).subscribe((data: any[]) => {
            this.rowData = data;
            this.rowData.forEach(row => {
                row['locked'] = true;
            })
            this.isDisabled = false;
        });
    }

    getColumnDef() {
        return [
            { headerName: "Lock", width: 70, cellRendererFramework: EditComponent, editable: false, pinned: true, hide: this.commonService.isHidden() },
            { headerName: "Report Id", field: "reportId", width: 100, editable: false },
            { headerName: "Report Name", field: "reportName", width: 250, editable: this.isEditable },
            { headerName: "Report Path", field: "url", width: 600, editable: this.isEditable },
            {
                headerName: "Is Active", field: "active", width: 100, editable: this.isEditable,
                cellEditor: 'select',
                cellEditorParams: {
                    values: ['true', 'false']
                }
            },
            {
                headerName: "Schedulable", field: "schedulable", width: 140, editable: this.isEditable,
                cellEditor: 'select',
                cellEditorParams: {
                    values: ['true', 'false']
                }
            },
            { headerName: "Created Date", field: "createdDate", width: 70, editable: false },
            { headerName: "Modified Date", field: "modifiedDate", width: 80, editable: false }
        ];
    }

    exportToCSV() {
        this.gridOptions.api.exportDataAsCsv();
    }

    syncWithCognos() {
        this.isSyncing = true;
        this.gridOptions.api.showLoadingOverlay();
        var selectedfoldername = "";
        this.service.repFolders.forEach(foldr => {
            if (foldr.folderId == this.folderId)
                selectedfoldername = foldr.folderName;
        });
        this.service.syncWithCognos().subscribe((data1: any) => {

            this.service.getRepoFolders().subscribe((data: RepoFolder[]) => {
                this.service.repFolders = data;
                this.service.repFolders.unshift(this.allMyFolderplaceholder);
                this.service.repFolders.unshift(this.allCompFolderplaceholder);
                this.service.repFolders.unshift(this.allFolderplaceholder);
                this.ddComponent.repofolders = this.service.repFolders;
                this.service.repFolders.forEach(foldr => {
                    if (foldr.folderName == selectedfoldername)
                        this.folderId = foldr.folderId;
                });
                this.getRowData();
                console.log(this.service.repFolders);
                let dialogData = {
                    isError: false,
                    header: 'Information',
                    message: 'Sync with Cognos successful!'
                }
                this.commonService.showDialog(dialogData);
                this.isSyncing = false;
                this.gridOptions.api.hideOverlay();
            });
        });
    }

    rowEditingStarted(params) {
        this.tempRowData = { ...params.data };
        delete this.tempRowData['locked'];
    }

    rowEditingStopped(params) {
        var tempRowData2 = { ...params.data };
        delete tempRowData2['locked'];

        if (JSON.stringify(this.tempRowData) !== JSON.stringify(tempRowData2) && !params.data.locked) {
            params.api.stopEditing(true);
            this.gridOptions.api.showLoadingOverlay();
            this.service.saveRowData(params.data).subscribe(data => {
                params.data.locked = true;
                this.gridOptions.api.hideOverlay();
            });
        }
    }

    isEditable(params) {
        return !params.node.data.locked;
    }


}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/folderdetailwidget-grid/folderdetailwidget-grid.component.ts